module.exports = __webpack_public_path__ + "static/media/LogoAlgar.cd1ae37d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/svg/LogoAlgar.svg
// module id = 1286
// module chunks = 0